module.exports = __webpack_public_path__ + "public/Icons/Language-icon.svg?bc76d9a9";